import createIcon from '../../createIcon';

/**
 * @component @name CollectionsBookmark
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCA2SDJWMjBDMiAyMS4xIDIuOSAyMiA0IDIySDE4VjIwSDRWNloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMCAySDhDNi45IDIgNiAyLjkgNiA0VjE2QzYgMTcuMSA2LjkgMTggOCAxOEgyMEMyMS4xIDE4IDIyIDE3LjEgMjIgMTZWNEMyMiAyLjkgMjEuMSAyIDIwIDJaTTIwIDEyTDE3LjUgMTAuNUwxNSAxMlY0SDIwVjEyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CollectionsBookmark = createIcon('CollectionsBookmark', [
  ['path', { d: 'M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6Z', key: '7m1wx6' }],
  [
    'path',
    {
      d: 'M20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 12L17.5 10.5L15 12V4H20V12Z',
      key: '9f8gud',
    },
  ],
]);

export default CollectionsBookmark;
